import React, { useEffect, useState } from "react";
import Button from "../../../../../shared/ui/inputs/classicButton.js";
import CountSelector from "../formatCountSelector/formatCountSelector.js";
import "./formatsCountSelector.css";
import ProcessingAnimation from "../../../../../../../merchant/panel/scripts/shared/ProcessingAnimation/ProcessingAnimation.js";
export default function FormatsCountSelector(props) {
    const { withoutGoBackButton = false } = props;
    const [formatsState, setFormatsState] = useState(props.formatNames
        .map((formatName, index) => {
        const format = props.offer.formats[index];
        if (format["@hidden"] === true)
            return undefined;
        return {
            name: formatName,
            count: 0,
        };
    })
        .filter((format) => format));
    const [selectorOpened, setSelectorOpened] = useState(false);
    useEffect(() => {
        const timeout = setTimeout(() => {
            setSelectorOpened(true);
        }, 100);
        return () => {
            clearTimeout(timeout);
        };
    }, []);
    return (React.createElement("div", { className: selectorOpened ?
            "format-selector-container format-selector-container-open"
            : "format-selector-container" },
        props.isLoading && React.createElement(ProcessingAnimation, null),
        props.formatNames.map((formatName, index) => (React.createElement(CountSelector, { key: index, offer: props.offer, format: props.offer.formats[index], formatName: formatName, onChange: function (value) {
                setFormatsState((old) => old.map((formatState) => formatState.name == formatName ?
                    { ...formatState, count: value }
                    : formatState));
            } }))),
        React.createElement("div", { className: "order-buttons-container" },
            React.createElement("div", { className: "order-buttons-wrapper" },
                withoutGoBackButton === false && (React.createElement(Button, { text: "Anuluj", value: "go-back", version: "alternative", onClick: props.onReject })),
                React.createElement(Button, { text: "Dodaj do koszyka", value: "add-to-cart", onClick: () => props.onAccept(formatsState) },
                    React.createElement("div", { className: "add-to-bucket-button-container" },
                        "Dodaj do koszyka",
                        React.createElement("img", { height: 25, src: "/assets/icons/buy-icon.svg" })))))));
}
